import client from './main-client';

export const fetchBorrowerNotesApi = (params) => client().get('/borrower-notes?&getAll=true', { params });
export const getBorrowerNoteApi = ({ id, ...params }) => client().get(`/borrower-notes/${id}`, { params });
export const updateBorrowerNoteApi = (params) => client().put(`/borrower-notes/${params.id}`, params);
export const addBorrowerNoteApi = (data) => client().post('/borrower-notes', data);
export const deleteBorrowerNoteApi = (params) => client().delete(`/borrower-notes/${params.id}`, { params });
